const propTypes={};export default propTypes;